import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';
import type { FC, HTMLAttributes } from 'react';

import s from './CardTime.module.css';

const variants = cva(s.time, {
  defaultVariants: {
    variant: 'primary',
  },
  variants: {
    variant: {
      invert: s.variant_invert,
      neutral: s.variant_neutral,
      primary: s.variant_primary,
    },
  },
});

type CardTimeProps = HTMLAttributes<HTMLParagraphElement> &
  VariantProps<typeof variants> & {
    time: string;
  };

const CardTime: FC<CardTimeProps> = ({ className, time, variant, ...props }) => (
  <p className={variants({ className, variant })} {...props}>
    {time}
  </p>
);

export { CardTime };
